"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopProductTwister = void 0;
const react_1 = __importStar(require("react"));
const router_1 = require("next/router");
const monera_app_core_1 = require("@amzn/monera-app-core");
const __1 = require("..");
const RegularTwister_1 = require("./RegularTwister");
const SelectorTwister_1 = require("./SelectorTwister");
const DesktopProductTwister = ({ variationMap = {}, dimensionKeys = [], dimensionValues = [], selectorView = false, seeAvailableOptionsCopy }) => {
    const [configStoreState] = (0, monera_app_core_1.useConfigStore)();
    const [variationState] = (0, react_1.useState)((0, __1.getVariationValuesFromAsin)(variationMap, configStoreState.asin) || []);
    const [hoverState, setHoverState] = (0, react_1.useState)(undefined);
    const router = (0, router_1.useRouter)();
    const handleOnClick = (dimensionKeyIndex, dimensionValueIndex) => __awaiter(void 0, void 0, void 0, function* () {
        const newState = [...variationState];
        newState[dimensionKeyIndex] = dimensionValueIndex;
        const asin = (0, __1.getAsinFromVariation)(variationMap, newState) ||
            (0, __1.getAsinFromClick)(variationMap, dimensionKeyIndex, dimensionValueIndex);
        const currentPath = router.asPath;
        const newPath = currentPath.substring(0, currentPath.indexOf('/dp/')) + '/dp/[asin]';
        asin &&
            router.replace({
                pathname: newPath,
                query: Object.assign(Object.assign({}, router.query), { asin, ref: `twister_${configStoreState.asin}` })
            });
    });
    return dimensionKeys.length !== 0 ? (react_1.default.createElement(react_1.default.Fragment, null, dimensionKeys.map(({ displayString }, dimensionKeyIndex) => {
        const twisterProps = {
            dimensionKeyIndex,
            displayString,
            dimensionValues,
            variationState,
            variationMap,
            handleOnClick,
            setHoverState,
            hoverState,
            seeAvailableOptionsCopy
        };
        return selectorView ? (react_1.default.createElement(SelectorTwister_1.SelectorTwister, Object.assign({}, twisterProps, { key: dimensionKeyIndex }))) : (react_1.default.createElement(RegularTwister_1.RegularTwister, Object.assign({}, twisterProps, { key: dimensionKeyIndex })));
    }))) : null;
};
exports.DesktopProductTwister = DesktopProductTwister;
